import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

export default function Breadcrumbs() {
  const location = useLocation();
  const pathname = location.pathname;

  // Split pathname into segments and remove empty strings
  const segments = pathname.split("/").filter((segment) => segment);

  // Create breadcrumb items with proper paths
  const breadcrumbs = segments.map((segment, index) => {
    // Build the path for this breadcrumb
    const path = `/${segments.slice(0, index + 1).join("/")}`;

    // Format the segment for display
    const displayName = formatBreadcrumbName(segment);

    return {
      name: displayName,
      path,
      isLast: index === segments.length - 1,
    };
  });

  return (
    <div className="container mx-auto">
      <nav className="bg-card dark:bg-card-dark px-6 py-3">
        <ol className="flex items-center space-x-2 text-sm">
          <li>
            <Link to="/" className="text-muted-foreground hover:text-info">
              Home
            </Link>
          </li>

          {breadcrumbs.map((breadcrumb, index) => (
            <li key={index} className="flex items-center">
              <span className="mx-2 text-muted-foreground/60">/</span>
              {breadcrumb.isLast ? (
                <span className="font-medium text-foreground">
                  {breadcrumb.name}
                </span>
              ) : (
                <Link
                  to={breadcrumb.path}
                  className="text-muted-foreground hover:text-info"
                >
                  {breadcrumb.name}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </div>
  );
}

// Helper function to format breadcrumb names
function formatBreadcrumbName(segment: string): string {
  // Handle dynamic route parameters (e.g., [businessId])
  if (segment.startsWith("[") && segment.endsWith("]")) {
    const paramName = segment.slice(1, -1);
    // For dynamic segments, we'll just use a capitalized version of the parameter name
    return paramName.charAt(0).toUpperCase() + paramName.slice(1);
  }

  // Check if segment is a UUID (format: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx)
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  if (uuidRegex.test(segment)) {
    return "Details";
  }

  // Add mappings for common routes
  const nameMap: Record<string, string> = {
    businesses: "Businesses",
    locations: "Locations",
    users: "Users",
    cameras: "Cameras",
    settings: "Settings",
    admin: "Admin",
    search: "Search",
    // Add more mappings as needed
  };

  return (
    nameMap[segment] ||
    segment
      .replace(/-/g, " ")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ")
  );
}
